// src/pages/Settings/SettingsLayout.tsx
import { NavLink, Outlet } from 'react-router-dom';
// console.log("🟨🟩🟪🟥🟦🟫⬛️ Loading <pages/Settings/SettingsLayout>")


const tabs = [
  { to: '/settings/profile', label: 'Profile' },
  { to: '/settings/billing-info', label: 'Billing Info' },
  { to: '/settings/payment-history', label: 'Payment History' },
];


const SettingsLayout = () => {
  return (
    <div className="p-6">
      {/* ===== Tabs Card ===== */}
      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-sm mb-6">
        <div className="flex border-b overflow-x-auto">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `
                px-6 py-4 whitespace-nowrap text-sm font-medium
                border-b-2 transition-colors
                ${
                  isActive
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }
              `
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>

      {/* ===== Content Area ===== */}
      <div className="max-w-5xl mx-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;